import styled from 'styled-components';

import { Text, Tag, Card } from '@gympass/yoga';
import { AlertTriangle, Info } from '@gympass/yoga-icons';

import { StyledTableProps } from './types';

export const Container = styled.main`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  min-height: 100vh;
  height: 100%;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
`;

export const ContentWrapper = styled.section`
  padding: ${({ theme }) => theme.yoga.spacing.zero}
    ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const HeaderTitle = styled(Text.H4)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
  line-height: ${({ theme }) =>
    theme.yoga.lineHeights.sessionHistoryTitleLineHeight}px;
`;

export const StyledCard = styled(Card)`
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  padding: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const CardHeader = styled(Card.Header)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${props =>
    props.isClosedInvoice
      ? props.theme.yoga.colors.deep
      : props.theme.yoga.colors.text.primary};
  font-size: ${({ theme }) => theme.yoga.fontSizes.large}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const TotalCard = styled.section`
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  position: sticky;
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  background-color: ${({ theme }) => theme.yoga.colors.white};
  box-shadow: ${({ theme }) => theme.yoga.elevations.medium};
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.large}px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const TotalWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
`;

export const TotalText = styled(Text.H4)`
  text-align: right;
  color: ${({ theme }) => theme.yoga.colors.deep};
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const TotalValue = styled(Text.H4)<StyledTableProps>`
  text-indent: ${({ theme }) => theme.yoga.spacing.small}px;
  color: ${props =>
    props.isClosedInvoice
      ? props.theme.yoga.colors.deep
      : props.theme.yoga.colors.text.primary};
`;

export const InvoiceCloseTag = styled(Tag.Informative).attrs(props => ({
  variant: props.status === 'open' ? 'success' : 'neutral',
  icon: props.status === 'open' ? Info : AlertTriangle,
}))``;

export const SubHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const DatePaginationContainer = styled.div`
  display: flex;
  align-items: center;
`;
